import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    ArInsightsReportType,
    GetCanDownloadInsightsReportResponse,
    GetInsightsReportDownloadUrlResponse,
    GetInsightsReportDownloadUrlService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { FileType } from '@lsq-frontend/remote-services/enterprise/common';
import { DownloadService, FeatureFlagService } from '@lsq-frontend/common-ui';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { FeatureFlags } from '@lsq-frontend/fasttrack-shared/app-constants';
import { LsqDataSource } from '@lsq-frontend/angular-shared/api-service';
import { Observable } from 'rxjs';

@Component({
    selector: 'portfolio-report-card',
    templateUrl: './portfolio-report-card.component.html',
    styleUrls: ['./portfolio-report-card.component.scss']
})
export class PortfolioReportCardComponent implements OnInit, OnDestroy {
    @Input() public canDownloadInsightsReportDataSource: LsqDataSource<
        GetCanDownloadInsightsReportResponse
    >;

    public canDownloadInsightsReportData$: Observable<GetCanDownloadInsightsReportResponse>;
    public reportIsLoading: boolean = false;

    constructor(
        private _featureFlagsService: FeatureFlagService,
        private _downloadService: DownloadService,
        private _getInsightsReportDownloadUrlService: GetInsightsReportDownloadUrlService,
        private _userService: UserService
    ) {}

    public ngOnInit(): void {
        if (this.canDownloadInsightsReportDataSource) {
            this.canDownloadInsightsReportData$ = this.canDownloadInsightsReportDataSource.connect();
        }
    }

    public ngOnDestroy(): void {
        if (this.canDownloadInsightsReportDataSource) {
            this.canDownloadInsightsReportDataSource.disconnect();
        }
    }

    public async downloadReport(): Promise<void> {
        this.reportIsLoading = true;
        const customerReportDownloadUrl: GetInsightsReportDownloadUrlResponse = await this._getInsightsReportDownloadUrlService.executeOnce(
            {
                companyKey: this._getCompanyKey(),
                debtorKey: null,
                reportType: ArInsightsReportType.Portfolio
            }
        );
        if (customerReportDownloadUrl.code !== 200) {
            return;
        }

        await this._downloadService
            .executeUrl(
                customerReportDownloadUrl.presignedUrl,
                FileType.Pdf,
                customerReportDownloadUrl.fileName
            )
            .catch((err) => console.log(err));
        this.reportIsLoading = false;
    }

    public creditReportFeatureFlag$ = this._featureFlagsService.isOn(
        FeatureFlags.ArInsightsReportDownloads
    );

    private _getCompanyKey(): string {
        return this._userService.getCompanyKey();
    }
}
